<tiime-table-anchor></tiime-table-anchor>
<table tiime-table tiimeStickyTable [dataSource]="audits" [trackBy]="trackById" aria-label="Liste des modifications">
  <ng-container [cdkColumnDef]="ColumnNames.date">
    <th cdk-header-cell *cdkHeaderCellDef>Date</th>
    <td cdk-cell *cdkCellDef="let audit">
      <span>{{ audit.recordedAt | date: 'dd/MM/YYYY' }}</span>
      <span class="time">à {{ audit.recordedAt | date: 'HH:mm' }}</span>
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.user">
    <th cdk-header-cell *cdkHeaderCellDef>Utilisateur</th>
    <td cdk-cell *cdkCellDef="let audit">
      <span>{{ audit | timelineItemDescription: 'fullName' }}</span>
      @if (audit.actor?.type !== 'system') {
        <span class="email" [tiimeTooltip]="audit.actor?.email" tooltipHideWithoutEllipsis>
          {{ audit | timelineItemDescription: 'email' }}
        </span>
      }
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.status" ]>
    <th cdk-header-cell *cdkHeaderCellDef>État</th>
    <td cdk-cell *cdkCellDef="let audit">
      <app-status [color]="audit.value | statusColor: statusType"></app-status>
      <span [tiimeTooltip]="audit.value | statusLabel: statusType" tooltipHideWithoutEllipsis>
        {{ audit.value | statusLabel: statusType }}
      </span>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns; let e = even" [class.alternate]="e"></tr>
</table>
